/* eslint-disable max-len */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-unused-vars */
import { useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { AiOutlineDownload } from 'react-icons/ai';
import { Button, ButtonDropdown } from 'ypf-pas-general-ui-components';
import { BsPlusCircle, BsTrash } from 'react-icons/bs';
import { useDropzone } from 'react-dropzone';

import ModalAddFile from '../../ModalAddFile/ModalAddFile';
import { FilesSdsPtContext } from '../../../../../../../context/FilesSdsPtContext';
import useToast from '../../../../../../../hooks/useToast';
import tableTypes from '../../../../../../../utils/filesTableTypes';
import { DetailRequest, DetailRequestMonthly } from '../../../../../../../utils/globalPropTypes';
import { MAX_DOWNLOAD_SIZE, MAX_FILE_SIZE } from '../../../../../../../constants/constants';
import {
  FILE_DOWNLOAD_TYPES,
  extensionCanOpenInBrowser
} from '../../../../../../../utils/downloadFiles';
import FilesFilters from '../../FilesFilters/FilesFilters';

import './ButtonHeader.scss';

const ButtonHeader = ({
  onlyButtonDeletedFiles,
  // disabledButtonDownloadDelete se fija si hay archivos seleccionados
  disabledButtonDownloadDelete,
  sds,
  setSelect,
  select,
  disableButtonSDSCancelled,
  type,
  details,
  permissions,
  approver,
  downloadOptions,
  attachedFiles,
  showFilters
}) => {
  const {
    downLoadFilesSDS,
    deleteFilesSDS,
    dataFilesSDS,
    setFieldValue,
    downLoadFilesPT,
    deleteFilesPT
  } = useContext(FilesSdsPtContext);
  const [showModal, setShowModal] = useState(false);

  const { id } = useParams();

  const { setNewToast } = useToast();
  const onDrop = (acceptedFiles) => {
    acceptedFiles.forEach((file) => {
      const reader = new FileReader();

      reader.readAsArrayBuffer(file);
    });
  };

  const onDropAccepted = (files) => {
    const values = dataFilesSDS;
    // Archivos repetidos
    const repeatedAttachments = files.filter((adj) =>
      values?.some(
        (fileAdj) => fileAdj.nombre === adj.name || fileAdj.nombre === `${id}_${adj.name}`
      )
    );
    // Archivos NO repetidos
    const noRepeatedAttachments = files.filter(
      (adj) =>
        !values.some(
          (fileAdj) => fileAdj.nombre === adj.name || fileAdj.nombre === `${id}_${adj.name}`
        )
    );

    // No se cargan los archivos repetidos
    // se notifica cuáles archivos son
    if (repeatedAttachments.length) {
      const quantitiesAttachments = repeatedAttachments.length > 1;

      setNewToast({
        type: 'ERROR',
        message: `${
          quantitiesAttachments
            ? `Los archivos
          ${repeatedAttachments.map(
            (repAdj, ind) => `${repAdj.name} ${ind + 1 === repeatedAttachments.length ? ',' : '-'}`
          )} ya se encuentran cargados`
            : `El archivo ${repeatedAttachments[0].name} ya se encuentra cargado`
        }`
      });
    }
    // Se cargan los archivos no repetidos
    if (noRepeatedAttachments?.length) {
      setFieldValue(files, id);
    }
  };

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
    onDropAccepted,
    maxSize: MAX_FILE_SIZE,
    noClick: true,
    noKeyboard: true,
    accept: 'pdf,.PDF,.jpg,.JPG,.jpeg,.JPEG,.msg,.xls,.xlsx,.png,.doc,.docx,.pptx,.ppt'
  });

  const download = (downloadType) => {
    // Elegir la funcion a utilizar para descargar
    const isSDS = type === tableTypes.sds || type === tableTypes.inactiveSDS;
    const isPT = type === tableTypes.inactivePT || type === tableTypes.pt;

    if (isSDS) downLoadFilesSDS(id, select, downloadType, type === tableTypes.inactiveSDS);
    if (isPT) downLoadFilesPT(select, downloadType, type === tableTypes.inactivePT);
    setSelect([]);
  };

  const deleteFile = () => {
    const isPtType = type === tableTypes.pt;

    if (isPtType) deleteFilesPT();
    if (!isPtType) deleteFilesSDS(id, select);
    setSelect([]);
  };

  const isNotOnlyPDFFiles = useMemo(
    () => !!attachedFiles.find((file) => select.includes(file.id) && !file.nombre.endsWith('.pdf')),
    [select, attachedFiles]
  );

  const canOpenInBrowser = useMemo(() => {
    const openInBrowserFiles = attachedFiles.reduce((acc, curr) => {
      if (!select.includes(curr.id)) return acc;
      if (
        extensionCanOpenInBrowser.some((ext) =>
          curr.nombre.toLowerCase().includes(ext.toLowerCase())
        )
      ) {
        return [...acc, curr.nombre];
      }

      return acc;
    }, []);

    return openInBrowserFiles.length > 1;
  }, [select, attachedFiles]);

  const options =
    downloadOptions?.map((option) => ({
      label: option.nombre,
      onClick: () => download(option.id),
      disabled:
        /**
         * Deshabilitamos la opcion de combinar PDF si los archivos seleccionados contienen otra extension y
         * deshabilitamos el boton de abrir en navegador si es mas de un archivo.
         */
        (option.id === FILE_DOWNLOAD_TYPES.COMBINE_PDF && isNotOnlyPDFFiles) ||
        (option.id === FILE_DOWNLOAD_TYPES.BROWSER && canOpenInBrowser)
    })) || [];

  const totalDownloadSize = useMemo(
    () =>
      /**
       * Obtenemos el total del peso de los archivos seleccionados, filtrando por los ids seleccionados
       */
      attachedFiles.reduce((acc, curr) => {
        if (!select.includes(curr.id)) return acc;

        return acc + curr.peso;
      }, 0) / 1024,

    [select, attachedFiles]
  );

  const isDownloadLimitExceded = totalDownloadSize > MAX_DOWNLOAD_SIZE;

  return (
    <div className="d-flex flex-column">
      {!sds && !onlyButtonDeletedFiles && !approver && (
        <div className="align-self-end">
          <Button
            colorIcon={!permissions.upload || disableButtonSDSCancelled ? 'dark' : 'primary'}
            disabled={!permissions.upload || disableButtonSDSCancelled}
            fontSizeLabel="15px"
            icon={BsPlusCircle}
            iconRight
            label="Agregar adjunto"
            onClick={() => setShowModal(true)}
            sizeIcon="17px"
            type="button"
            variant="light-gray"
            widthButton="180px"
          />
        </div>
      )}
      <div className="d-flex styles-content-buttons align-items-center justify-content-between">
        <div className="containers-buttons download-files align-items-center">
          <ButtonDropdown
            disabled={
              !permissions.download ||
              disabledButtonDownloadDelete ||
              !select.length ||
              isDownloadLimitExceded
            }
            label={<AiOutlineDownload size={15} />}
            options={options}
          />
          {!onlyButtonDeletedFiles && !approver && (
            <Button
              colorIcon={
                !permissions.delete ||
                disabledButtonDownloadDelete ||
                disableButtonSDSCancelled ||
                !select.length
                  ? 'dark'
                  : 'danger'
              }
              disabled={
                !permissions.delete ||
                disabledButtonDownloadDelete ||
                disableButtonSDSCancelled ||
                !select.length
              }
              icon={BsTrash}
              onClick={deleteFile}
              type="button"
              variant="light-gray"
              widthButton="40px"
            />
          )}
          {isDownloadLimitExceded && (
            <div className="container-alert">
              {/* TODO el límite de descarga no está confirmado */}
              <p>
                Has alcanzado un total de {Math.ceil(totalDownloadSize)}KB. El límite de descarga es
                de {MAX_DOWNLOAD_SIZE} KB
              </p>
            </div>
          )}
        </div>

        {/* Archivos de solicitud */}
        {sds && !approver && (
          <div {...getRootProps()}>
            <input {...getInputProps()} value={undefined} />
            <Button
              colorIcon={!permissions.upload || disableButtonSDSCancelled ? 'dark' : 'primary'}
              disabled={!permissions.upload || disableButtonSDSCancelled}
              fontSizeLabel="15px"
              icon={BsPlusCircle}
              iconRight
              label="Agregar adjuntos"
              onClick={open}
              sizeIcon="17px"
              type="button"
              variant="light-gray"
              widthButton="180px"
            />
          </div>
        )}
        {showFilters && <FilesFilters details={details} />}
      </div>
      {!approver && (
        <ModalAddFile
          canAddFile={permissions.upload}
          details={details}
          getInputProps={getInputProps}
          getRootProps={getRootProps}
          open={open}
          setShowModal={setShowModal}
          showModal={showModal}
          type={type}
        />
      )}
    </div>
  );
};

export default ButtonHeader;

ButtonHeader.propTypes = {
  permissions: PropTypes.shape({
    delete: PropTypes.bool,
    download: PropTypes.bool,
    upload: PropTypes.bool
  }),
  onlyButtonDeletedFiles: PropTypes.bool,
  disabledButtonDownloadDelete: PropTypes.bool.isRequired,
  sds: PropTypes.bool,
  setSelect: PropTypes.func,
  select: PropTypes.arrayOf(PropTypes.number),
  disableButtonSDSCancelled: PropTypes.bool,
  type: PropTypes.string,
  details: PropTypes.oneOfType([DetailRequest, DetailRequestMonthly]),
  approver: PropTypes.bool,
  downloadOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      nombre: PropTypes.string
    })
  ),
  attachedFiles: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number
    })
  ),
  showFilters: PropTypes.bool
};

ButtonHeader.defaultProps = {
  permissions: {
    delete: false,
    download: true,
    upload: false
  },
  onlyButtonDeletedFiles: false,
  sds: false,
  setSelect: () => {},
  disableButtonSDSCancelled: false,
  type: '',
  select: [],
  details: {},
  approver: false,
  downloadOptions: [],
  attachedFiles: [],
  showFilters: false
};
